import { useState } from 'react'
import { FaTimes, FaCheck, FaExclamationTriangle, FaInfo, FaQuestion } from 'react-icons/fa'
import './ModalDemo.css'

function ModalDemo() {
  const [modal1Open, setModal1Open] = useState(false)
  const [modal2Open, setModal2Open] = useState(false)
  const [modal3Open, setModal3Open] = useState(false)
  const [confirmResult, setConfirmResult] = useState(null)

  const handleConfirm = () => {
    setConfirmResult('confirmed')
    setModal3Open(false)
    setTimeout(() => setConfirmResult(null), 3000)
  }

  const handleCancel = () => {
    setConfirmResult('cancelled')
    setModal3Open(false)
    setTimeout(() => setConfirmResult(null), 3000)
  }

  return (
    <div className="modal-demo">
      <section className="demo-section">
        <h4>基础模态框</h4>
        <div className="modal-buttons">
          <button className="btn btn-primary" onClick={() => setModal1Open(true)}>
            打开基础模态框
          </button>
          <button className="btn btn-success" onClick={() => setModal2Open(true)}>
            成功提示
          </button>
          <button className="btn btn-warning" onClick={() => setModal3Open(true)}>
            确认对话框
          </button>
        </div>
        
        {confirmResult && (
          <div className={`confirm-result ${confirmResult}`}>
            {confirmResult === 'confirmed' ? (
              <><FaCheck /> 操作已确认</>
            ) : (
              <><FaTimes /> 操作已取消</>
            )}
          </div>
        )}
      </section>

      {/* 基础模态框 */}
      {modal1Open && (
        <div className="modal-overlay" onClick={() => setModal1Open(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                <FaInfo /> 基础信息
              </h3>
              <button 
                className="modal-close"
                onClick={() => setModal1Open(false)}
              >
                <FaTimes />
              </button>
            </div>
            <div className="modal-body">
              <p>这是一个基础的模态框示例。</p>
              <p>你可以在模态框中放置任何内容。</p>
              <p>点击背景或关闭按钮可以关闭模态框。</p>
            </div>
            <div className="modal-footer">
              <button 
                className="btn btn-secondary"
                onClick={() => setModal1Open(false)}
              >
                关闭
              </button>
              <button 
                className="btn btn-primary"
                onClick={() => setModal1Open(false)}
              >
                确定
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 成功提示 */}
      {modal2Open && (
        <div className="modal-overlay success" onClick={() => setModal2Open(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header success">
              <h3 className="modal-title">
                <FaCheck /> 操作成功
              </h3>
            </div>
            <div className="modal-body">
              <div className="success-icon">
                <FaCheck />
              </div>
              <p className="success-text">您的操作已成功完成！</p>
            </div>
            <div className="modal-footer">
              <button 
                className="btn btn-success"
                onClick={() => setModal2Open(false)}
              >
                好的
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 确认对话框 */}
      {modal3Open && (
        <div className="modal-overlay warning" onClick={() => setModal3Open(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header warning">
              <h3 className="modal-title">
                <FaQuestion /> 确认操作
              </h3>
            </div>
            <div className="modal-body">
              <div className="warning-icon">
                <FaExclamationTriangle />
              </div>
              <p className="warning-text">您确定要执行此操作吗？</p>
              <p className="warning-hint">此操作无法撤销，请谨慎操作。</p>
            </div>
            <div className="modal-footer">
              <button 
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                取消
              </button>
              <button 
                className="btn btn-warning"
                onClick={handleConfirm}
              >
                确认
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ModalDemo